// © Microsoft Corporation. All rights reserved.

/**
 * Enum for different auth cookie names
 * @enum
 */
export enum AuthCookieName {
    Anon = "ANON",
    AppAnon = "APP_ANON",
    Unknown = ""
}

/**
 * List of http-readable cookies that indicate the presence of an auth cookie
 */
export enum AuthCookieExistsCookieName {
    AnonCookieExists = "ace",
    AppAnonCookieExists = "aace"
}

/**
 * Original source is Constants.ts
 * Child cookie name, used to signal if rpsUser is child account.
 */
export const childCookieName = "child";